import { MicroServiceName } from '../../types';

let serviceName: MicroServiceName | null = null;

export const setServiceName = (name: MicroServiceName): void => {
    serviceName = name;
};

export const getServiceName = (): MicroServiceName => serviceName as MicroServiceName;
